import {
  AdminPanelSettingsOutlined,
  InsertDriveFileOutlined,
  HomeOutlined,
  FavoriteBorderOutlined,
  CreditCardOutlined,
  MailOutline,
  SettingsOutlined,
  PeopleOutlined,
  FlagOutlined,
  PlaceOutlined,
  InsightsOutlined,
} from "@mui/icons-material";
import { Pages } from "../../../../utils";
import { SidebarConfigItem } from "./SidebarMenu";

export const getAdminSidebarConfig = (): SidebarConfigItem[] => [
  {
    name: "Admin Dashboard",
    path: Pages.DASHBOARD,
    icon: <AdminPanelSettingsOutlined sx={{ color: "#fff" }} />,
  },
  {
    name: "Designer Applications",
    path: Pages.ADMIN_DESIGNER_APPLICATIONS,
    icon: <InsertDriveFileOutlined sx={{ color: "#fff" }} />,
  },
  {
    name: "Homeowner Accounts",
    path: Pages.ADMIN_HOMEOWNER_ACCOUNTS,
    icon: <HomeOutlined sx={{ color: "#fff" }} />,
  },
  {
    name: "Matches",
    path: Pages.ADMIN_MATCHES,
    icon: <FavoriteBorderOutlined sx={{ color: "#fff" }} />,
  },
  {
    name: "Membership Plans",
    path: Pages.ADMIN_MEMBERSHIP_PLANS,
    icon: <CreditCardOutlined sx={{ color: "#fff" }} />,
  },
  {
    name: "Feature Flags",
    path: Pages.ADMIN_FEATURE_FLAGS,
    icon: <FlagOutlined sx={{ color: "#fff" }} />,
  },
  {
    name: "DMA Availability",
    path: Pages.ADMIN_DMA_AVAILABILITY,
    icon: <PlaceOutlined sx={{ color: "#fff" }} />,
  },
  {
    name: "Messages",
    path: Pages.ADMIN_MESSAGES,
    icon: <MailOutline sx={{ color: "#fff" }} />,
  },
  {
    name: "Event Attribution",
    path: Pages.ADMIN_EVENT_ATTRIBUTION,
    icon: <InsightsOutlined sx={{ color: "#fff" }} />,
  },
  {
    name: "Utilities",
    subItems: [
      {
        name: "Admin Users",
        path: Pages.ADMIN_USER_MANAGEMENT,
        icon: <PeopleOutlined sx={{ color: "#fff" }} />,
      },
      {
        name: "Settings",
        path: Pages.PROFILE,
        icon: <SettingsOutlined sx={{ color: "#fff" }} />,
      },
    ],
  },
];
